interface CompetingThemesCellProps {
  themes: string[];
}

export const CompetingThemesCell = ({ themes }: CompetingThemesCellProps) => {
  const firstThreeThemes = themes.slice(0, 3);
  return <span>{firstThreeThemes.join(', ')}</span>;
};
